import Http from '@/classes/http/Http'
import Transform from '@/classes/form/Transform'

export default {
  getInvoiceCustomers (filter) {
    return Http.get({
      url: `invoice-customers${filter}`
    })
  },
  getInvoiceCustomer (invoiceCustomerId) {
    return Http.get({
      url: `invoice-customers/${invoiceCustomerId}`
    })
  },
  getHistoricalInvoiceCustomer (invoiceId) {
    return Http.get({
      url: `historical-invoice-customers/${invoiceId}`
    })
  },
  getInvoiceCustomerCreateForm () {
    return Http.get({
      url: `invoice-customers/form`
    })
  },
  getInvoiceCustomerEditForm (invoiceCustomerId) {
    return Http.get({
      url: `invoice-customers/${invoiceCustomerId}/form`
    })
  },
  postInvoiceCustomerCreateForm (formData) {
    return Http.post({
      url: `invoice-customers/form`,
      data: Transform.createMultipartFormData(formData)
    })
  },
  patchInvoiceCustomerEditForm (invoiceCustomerId, formData) {
    return Http.patch({
      url: `invoice-customers/${invoiceCustomerId}/form`,
      data: Transform.createMultipartFormData(formData)
    })
  }
}
